import positionData from "@/assets/js/position-data";
import roleData from "@/assets/data/role-data.json";
import {centre} from "@/assets/js/position-data";
import Position from "@/assets/js/position";
import Role from "@/assets/js/role";


const state = () => {
  const positions = {};
  for (const [key, position] of Object.entries(positionData)) {
    const positionGroup = position.positionGroup;
    const possibleRoles = [];

    Object.values(roleData[positionGroup]).forEach((role) => {
      const positionGroupRoles = Object.values(role).map((duty) => new Role(duty));
      possibleRoles.push(...positionGroupRoles);
    });

    positions[key] = new Position(position, possibleRoles);
  }
  return positions;
};

const mutations = {
  setRole (state, value) {
    state[value.position].selectedRole = value.role;
  },

  setPositionFilled (state, value) {
    state[value.position].filled = value.filled;
  },

  setCustomInstruction (state, value) {
    state[value.position].customInstructions.setInstruction(value.instructionKey, value.instructionValue);
  },

  clearCustomInstructions (state, value) {
    state[value].customInstructions.clearInstructions();
  }
};

const getters = {
  positions: (state) => (side = null) => {
    if (side == null) {
      return Object.values(state).filter(position => position.filled);
    }
    return Object.values(state).filter(position =>
      position.filled && (position.side === side || position.side === centre)
    );
  },

  positionPlayerInstructions: (state) => (positionNumber) => {
    const position = Object.values(state).find(position => position.positionNumber === positionNumber);
    if (!position) return [];    
    return position.playerInstructions.listInstructions();
  }
};

export default {
  state,
  mutations,
  getters
};
